<template>

    <b-container>

      <div class="mt-4 burger-spacing d-flex justify-content-between">
        <back-arrow :title="$t('Modify') + ' ' + $t('a.e')  + ' ' +  $t('commission')"/>
      </div>

      <div class="row mt-4">
        <div class="col-md-12">
          <b-card class="mt-2 mb-4 shadow-sm">
            <b-form @submit.stop.prevent="onSubmit">

              <div class="row">

                <!-- nom -->
                <div class="col-md-6">
                  <string-field
                    :label="$t('commission.Name') + $t('field.mandatory')"
                    :id="'name-input'"
                    :input-value="this.form.name"
                    v-model="this.form.name"
                    :is-required="true">
                  </string-field>
                </div>

                <!-- displayOrder -->
                <div class="col-md-6">
                  <number-field
                    :label="$t('commission.DisplayOrder') + $t('field.mandatory')"
                    :id="'displayOrder-input'"
                    :input-value="this.form.displayOrder"
                    :min="1"
                    :step="1"
                    v-model="this.form.displayOrder"
                    :is-required="true">
                  </number-field>
                </div>

              </div>

              <div class="d-flex justify-content-end">
                <b-button type="submit" variant="secondary">{{ $t('Validate') }}</b-button>
              </div>

            </b-form>
          </b-card>
        </div>
      </div>

    </b-container>

</template>

<script>

import api from '../../services/api'
import BackArrow from '../../components/b122/BackArrow'
import StringField from "../../components/b122/editFields/StringField.vue";
import NumberField from "../../components/b122/editFields/NumberField.vue";

export default {

  name: 'CommissionEdit',

  components: {
    NumberField,
    StringField,
    BackArrow
  },

  data () {
    return {
      commissionId: this.$route.params.commissionId,
      commission: null,
      form: {
        name:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        displayOrder:
          {
            state: null,
            invalidFeedback: null,
            value: null
          }
      }
    }
  },

  mounted () {
    this.fetchData()
  },

  methods: {

    fetchData () {
      this.fetchCommission()
    },

    fetchCommission () {
      api
        .get(`/commission/${this.commissionId}`)
        .then(response => {
          this.commission = response.data
          this.setInitialValues()
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'CommissionIndex',
              params: {
                message: error.response.data.message
              }
            })
          }
        })
    },

    setInitialValues () {
      this.form.name.value = this.commission.name
      this.form.displayOrder.value = this.commission.displayOrder
    },

    onSubmit () {

      let data = new FormData()
      data.append('name', this.form.name.value)
      data.append('displayOrder', this.form.displayOrder.value)

      api({
        method: 'POST',
        url: `commission/${this.commissionId}`,
        data: data
      })
        .then(() => {
          this.$router.push({
            name: 'CommissionIndex'
          }, () => {
            this.$nextTick(() => {
              this.successToast(this.form.name.value)
            })
          })
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'CommissionIndex',
              params: {
                message: error.response.data.message
              }
            })
          } else if (error.response.status === 403) {
            const invalidField = error.response.data.invalidField
            this.form[invalidField]['state'] = false
            this.form[invalidField]['invalidFeedback'] = this.$i18n.t(error.response.data.message)
          }
        })
    },

    successToast (name) {
      this.$bvToast.toast(this.$i18n.t('commission') + ' "' + name + '" ' + this.$i18n.t('f.modified'), {
        autoHideDelay: 2000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true
      })
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/views/commission/CommissionEdit.vue